import { useTheme } from "next-themes";
import { Sun, Moon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BRAND_NAME } from "@/lib/brand";

export const RestaurantBrand = ({ className = "", testId = "restaurant-logo" }) => (
  <img src="/restaurant-logo.png" alt={`${BRAND_NAME} — Restaurant & More`} width="495" height="354" className={`restaurant-logo ${className}`} data-testid={testId} />
);

export const ThemeToggle = () => {
  const { resolvedTheme, setTheme } = useTheme();
  const dark = resolvedTheme === "dark";
  return <Button variant="ghost" size="icon" onClick={() => setTheme(dark ? "light" : "dark")} aria-label={dark ? "Attiva tema chiaro" : "Attiva tema scuro"} title={dark ? "Tema chiaro" : "Tema scuro"} data-testid="theme-toggle">
    {dark ? <Sun /> : <Moon />}
  </Button>;
};

export const menuPrice = (value) => new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", minimumFractionDigits: 2 }).format(value);
